export default __webpack_public_path__ + "static/media/arrow.5cd346fd.svg";